import { Category } from "./../../../model/category";
import { Pdfs } from "../../../../assets/pdfs/pdfs";

export const schoolPricelists: Category[] = [
  {
    name: "Allendale Primary School Pricelist",
    image: "schools/allendale.jpg",
    ...Pdfs.Allendale2026
  },
  {
    name: "Champion Bay Senior High School Pricelist",
    image: "schools/cbshs.png",
    ...Pdfs.CBSHSUniformPriceList2026v2
  },
  {
    name: "Chapman Valley Primary School Pricelist",
    image: "schools/chapmanvalley.png",
    ...Pdfs.ChapmanValleyPS2026Pricelist
  },
  {
    name: "Geraldton Senior High School Pricelist",
    image: "schools/gshs.png",
    ...Pdfs.GSHSPriceList2026UpdateV1
  },
  {
    name: "Nagle Catholic College Pricelist",
    image: "schools/nagle.png",
    ...Pdfs.NagleCollegePriceList2026
  },
  {
    name: "Bluff Point Primary Pricelist",
    image: "schools/bps.png",
    ...Pdfs.BluffPointPriceList2026
  },
  {
    name: "Geraldton Primary Pricelist",
    image: "schools/gps2022.jpg",
    ...Pdfs.GeraldtonPrimaryGPSPriceList2026
  },
  {
    name: "St Francis Xavier Primary Pricelist",
    image: "schools/sfx.png",
    ...Pdfs.SFXUniformPricelist2026
  },
  {
    name: "St Lawrence Primary Pricelist",
    image: "schools/stlawrence.png",
    ...Pdfs.StLawrence2026PriceList
  },
  {
    name: "Wandina Primary Pricelist",
    image: "schools/wandina.png",
    ...Pdfs.WandinaUniformCatalogue2026
  },
  {
    name: "Mount Tarcoola Primary Pricelist",
    image: "schools/mtp.png",
    ...Pdfs.MTPPriceList2026
  },
  {
    name: "Waggrakine Primary Pricelist",
    image: "schools/Waggrakine.png",
    ...Pdfs.WaggrakinePrimaryPricelist2026
  },
  {
    name: "Yalgoo Primary Pricelist",
    image: "schools/Yalgoo.jpg",
    ...Pdfs.YalgooPS2026Pricelist
  },
  {
    name: "Binnu Primary School Pricelist",
    image: "schools/binnu-v1.png",
    ...Pdfs.BinnuPrimaryPriceList2026
  }
];

export const tafePricelists: Category[] = [
  {
    name: "Central Regional TAFE",
    image: "schools/cr-tafe.jpg",
    ...Pdfs.CRTAFECommercialCookeryPriceList2025
  }
]
